//AI results (bgremoved, upscaled, inpainted, outpainted, wmremoved...) may not be visible yet on the shared storage
//of the pod serving the request right after the "done" message --> retry loading with a cache buster

export const MAX_IMAGE_RETRIES = 5

export function canRetryImageUrl(url: string, retry: number): boolean {
    return !!url && !url.startsWith('data:') && !url.startsWith('blob:') && retry < MAX_IMAGE_RETRIES
}

export function getImageRetryDelay(retry: number): number {
    return 1000 * (retry + 1)
}

export function withImageRetryParam(url: string, retry: number): string {
    if (!url || !retry || url.startsWith('data:') || url.startsWith('blob:')) {
        return url
    }

    return `${url}${url.includes('?') ? '&' : '?'}retry=${retry}`
}
